import React from 'react';

import FieldText from '../common/FieldText';
import FieldDate from '../common/FieldDate';
import FieldSelect from '../common/FieldSelect';
import FieldMultiSelect from '../common/FieldMultiSelect';

class PropertyAddEditInfo extends React.Component {
  render() {
    const fields = this.props.model.fields;
    const property = this.props.property;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;
    return (
      <>
        <div className="formhead col-md-12"><h2>Property Information</h2></div>
        
        <FieldText key="property_id" id="property_id" field={fields.property_id}
          value={property.property_id} onValueChange={onValueChange} inValid={inValid} />

        <FieldText key="name" id="name" field={fields.name}
          value={property.name} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="property_type" id="property_type" field={fields.property_type}
          value={property.property_type} onValueChange={onValueChange} inValid={inValid} />
          
        <FieldSelect key="type" id="type" field={fields.type} value={property.type}
          onValueChange={onValueChange} inValid={inValid} />
        
        <FieldSelect key="property_transaction" id="property_transaction" field={fields.property_transaction}
          value={property.property_transaction} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="possession_type" id="possession_type" field={fields.possession_type}
          value={property.possession_type} onValueChange={onValueChange} inValid={inValid} />
        
        <FieldSelect key="transaction_type" id="transaction_type" field={fields.transaction_type}
          value={property.transaction_type} onValueChange={onValueChange} inValid={inValid} />

        <FieldMultiSelect key="responsible_person" id="responsible_person"
          field={fields.responsible_person} value={property.responsible_person}
          onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="property_status" id="property_status" field={fields.property_status}
          value={property.property_status} onValueChange={onValueChange} inValid={inValid} />

        <FieldDate key="available_date" id="available_date" field={fields.available_date}
          value={property.available_date} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="reference" id="reference" field={fields.reference}
          value={property.reference} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="rating" id="rating" field={fields.rating}
          value={property.rating} onValueChange={onValueChange} inValid={inValid} />

      </>
    );
  }
}

export default PropertyAddEditInfo;